import React from "react";

const Concatenation = () => {
  return (
    <div>
      <h1>Concatenation Component</h1>
      <p>Content for Concatenation goes here...</p>
    </div>
  );
};

export default Concatenation;
